module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Titles__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-family": "Timeless",
      "font-size": "4.00em"
    }
  }, [_vm._v("NATALIA BROTHERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Paragraphs__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_Paragraphs__And__Centre_Alignment__And__Left_Indent__And__Line_Spacing"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "",
      "src": "image0.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_Paragraphs__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_Paragraphs__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-family": "Timeless",
      "font-size": "1.67em"
    }
  }, [_vm._v("AURAS OF NIGHT")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 63
// module chunks = 0